import React from "react";

function KvmSurgicials() {
  return (
    <div className="commingsoon">
      <h1>Coming Soon..</h1>
    </div>
  );
}

export default KvmSurgicials;
